const Roles = {
  AGENCY: 'agency',
  ADMIN: 'admin',
  SUPERADMIN: 'superadmin',
}

module.exports = {
  Roles,
}
